export const DELETE_TASK = 'DELETE_TASK'
export const CHANGE_DAY_TASKS_STATUS = 'CHANGE_DAY_TASKS_STATUS'
export const CHANGE_TASK_STATUS = 'CHANGE_TASK_STATUS'
export const LOAD_TASKS_STATUS_CHANGES = 'LOAD_TASKS_STATUS_CHANGES'
export const REMOVE_EVENT_DAY_COURSES = 'REMOVE_EVENT_DAY_COURSES'
export const RESET_DAY_TASKS_CHANGES = 'RESET_DAY_TASKS_CHANGES'
export const SET_TASK_API_ERROR = 'SET_TASK_API_ERROR'
export const STORE_TASK_STATUS_CHANGE = 'STORE_TASK_STATUS_CHANGE'
